import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LevelSelection = ({ onChange, area }) => {
    const navigate = useNavigate();

    const [visibleLevels, setVisibleLevels] = useState([]);

    const allLevels = [
        { id: 'A2', label: 'A2', key: 'textA2' },
        { id: 'B1', label: 'B1', key: 'textB1' },
        { id: 'B2', label: 'B2', key: 'textB2' },
        { id: 'C1', label: 'C1', key: 'textC1' },
    ];

    // Filtrování podle podmínky: klíč musí existovat a mít neprázdnou hodnotu
    const filteredLevels = allLevels.filter((level) => {
        const value = area?.[level.key];
        return typeof value === 'string' && value.trim() !== '';
    });

    const handleSelectLevel = (level) => {
        onChange(level);
        navigate('/quiz/play');
    };

    useEffect(() => {
        if (filteredLevels.length === 1) {
            handleSelectLevel(filteredLevels[0]);
            return;
        }
        filteredLevels.forEach((level, i) => {
            setTimeout(() => {
                setVisibleLevels((prev) => [...prev, level.id]);
            }, i * 100);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [area]);

    return (
        <div id="quiz-levelSelection">

            <ul className="grid grid-cols-2 gap-6 mx-auto max-w-[400px]">
                {filteredLevels.map((level) => (
                    <li key={`level-${level.id}`}>
                        <button
                            onClick={() => handleSelectLevel(level)}
                            className={`btn-primary flex-col !p-6 w-full transition-transform transform text-5xl font-bold ${visibleLevels.includes(level.id) ? 'opacity-100' : 'opacity-0'}`}
                            style={{ transitionDuration: '0.5s' }}
                        >
                            {level.label}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default LevelSelection;
